export default __webpack_public_path__ + "static/media/for-players-alert.e37d7caf.svg";